'use client';

import { useState, useEffect } from 'react';
import Link from 'next/link';
import Image from 'next/image';
import Icon from '@/components/ui/AppIcon';

const Footer = () => {
  const [isHydrated, setIsHydrated] = useState(false);
  const [currentYear, setCurrentYear] = useState('2026');

  useEffect(() => {
    setIsHydrated(true);
    setCurrentYear(new Date().getFullYear().toString());
  }, []);

  if (!isHydrated) {
    return (
      <footer className="bg-textPrimary text-white pt-12 pb-6">
        <div className="container mx-auto px-4">
          <div className="grid md:grid-cols-2 gap-8 mb-8">
            <div className="h-32 bg-white/10 rounded animate-pulse"></div>
            <div className="h-32 bg-white/10 rounded animate-pulse"></div>
          </div>
        </div>
      </footer>
    );
  }

  return (
    <footer className="bg-textPrimary text-white pt-12 pb-6">
      <div className="container mx-auto px-4">
        <div className="grid md:grid-cols-2 gap-8 mb-8">
          <div className="space-y-4">
            <Link href="/homepage" className="flex items-center space-x-3">
              <Image
                src="/assets/Surilipat logo.jpg"
                alt="Surilipat Logo"
                width={48}
                height={48}
                className="rounded-lg"
              />
              <span className="text-xl font-heading font-bold">
                Surilipat<span className="text-secondary">.hub</span>
              </span>
            </Link>
            <p className="text-sm font-body opacity-80 leading-relaxed">
              Surilipat ialah platform yang menghubungkan pelanggan dengan ejen lipat dan gosok baju dari rumah. Semua ejen adalah individu dari komuniti setempat yang menawarkan servis kemasan pakaian secara fleksibel, telus dan berpatutan.
            </p>
          </div>

          <div className="md:justify-self-end">
            <h4 className="text-lg font-heading font-bold mb-4">Hubungi Kami</h4>
            <ul className="space-y-3">
              <li className="flex items-start space-x-2 text-sm font-body opacity-80">
                <Icon
                  name="PhoneIcon"
                  size={18}
                  variant="outline"
                  className="flex-shrink-0 mt-0.5"
                />
                <span>+60 11-7328 5813</span>
              </li>
              <li className="flex items-start space-x-2 text-sm font-body opacity-80">
                <Icon
                  name="EnvelopeIcon"
                  size={18}
                  variant="outline"
                  className="flex-shrink-0 mt-0.5"
                />
                <span>support@surilipat.com</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 pt-6">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-sm font-body opacity-80 text-center md:text-left">
              © {currentYear} Surilipat.hub  202503337510 (KT0604123-P) . Developed under The Wagmi Resources.
            </p>
            <div className="flex items-center space-x-4 text-sm font-body opacity-80">
              <Link href="/polisi-privasi" className="hover:text-primary transition-colors duration-300">
                Polisi Privasi
              </Link>
              <span>•</span>
              <Link href="/terma-perkhidmatan" className="hover:text-primary transition-colors duration-300">
                Terma Perkhidmatan
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
